import React from "react"
import { navigate, useStaticQuery, graphql } from "gatsby"
import AddressSearch from "../../../ui/AddressSearch/AddressSearch"
import { customRoutes } from "@utils/customRoutes"

const InputSearch = () => {
  const data = useStaticQuery(graphql`
    query {
      allSanityCity {
        nodes {
          city
          slug {
            current
          }
          state {
            state
          }
        }
      }
    }
  `)

  const findStateRoute = (decodedPlace: string) => {
    const segments = decodedPlace.split(", ")
    for (let i = segments.length - 1; i >= 0; i--) {
      const seg = segments[i].trim()
      const match = customRoutes.find(
        r => r.place.toUpperCase() === seg.toUpperCase() || r.route.toUpperCase() === seg.toUpperCase()
      )
      if (match) return match.route
    }
    return null
  }

  const normalizeCityName = (name: string) =>
    name
      .replace(/\bSt\.\s*/gi, "Saint ")
      .replace(/\bMt\.\s*/gi, "Mount ")
      .replace(/\bFt\.\s*/gi, "Fort ")
      .trim()
      .toUpperCase()

  const findCitySlug = (decodedPlace: string) => {
    const segments = decodedPlace.split(", ")
    const cityName = normalizeCityName(segments[0]?.trim() || "")
    const cities: any[] = data.allSanityCity?.nodes || []

    // Try city + state match, checking all segments after index 0 for the state
    // (Mapbox sometimes inserts a county between city and state, and uses
    // abbreviations like "St." that Sanity stores as "Saint")
    let match = cities.find(
      n =>
        normalizeCityName(n.city || "") === cityName &&
        segments.slice(1).some(seg => n.state?.state?.toUpperCase() === seg.trim().toUpperCase())
    )
    // Fall back to city name only
    if (!match) {
      match = cities.find(n => normalizeCityName(n.city || "") === cityName)
    }
    return match?.slug?.current || null
  }

  const handleRoute = (value: string, placeType?: string) => {
    const decodedPlace = decodeURIComponent(value)

    if (placeType === "region") {
      const stateRoute = findStateRoute(decodedPlace)
      if (stateRoute) { navigate(`/${stateRoute}`); return }
    }

    if (placeType === "place" || placeType === "locality") {
      const citySlug = findCitySlug(decodedPlace)
      if (citySlug) { navigate(`/${citySlug}`); return }
      window.location.href = `/report?address=${value}&type=${placeType}`
      return
    }

    if (placeType === "postcode") {
      const stateRoute = findStateRoute(decodedPlace)
      if (stateRoute) { navigate(`/${stateRoute}`); return }
      window.location.href = `/report?address=${value}&type=postcode`
      return
    }

    if (placeType === "address" || placeType === "poi" || !placeType) {
      window.location.href = `/report?address=${value}`
      return
    }

    window.location.href = `/report?address=${value}&type=${placeType}`
  }

  return <AddressSearch onSendAddress={handleRoute} />
}

export default InputSearch
